export default {
  signup: {
    server: '/sessions/signup',
    method: 'post',
  },
  signin: {
    server: '/sessions/signin',
    method: 'post',
  },
  verifyAvg: {
    server: '/sessions/auth-svg',
    method: 'get',
  },
  getForgetPsdVerify: {
    server: '/sessions/forget-password-verification',
    method: 'post',
  },
  resetPassword: {
    server: '/sessions/reset-password',
    method: 'post',
  },
};
